import React, { useEffect, useState } from 'react'
import SearchCandidate from '../../../components/companyUser/candidates/walkIn'
import { v3_qr_walk_in_candidates } from '../../../actions/v3/candidates'


const List = () => {

    const [list, setList] = useState(null);
    const [count, setCount] = useState(null);
    const [todayCount, setTodayCount] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [refresh, setRefresh] = useState(false);


    const [searchQuery, setSearchQuery] = useState({
        CANDIDATE_NAME: '',
        EMAIL: '',
        PHONE: '',
        SKILLS: '',
        FROM_DATE: '',
        TO_DATE: ''
    });


    useEffect(() => {

        v3_qr_walk_in_candidates(btoa(JSON.stringify({ PAGE: currentPage, ...searchQuery }))).then((res) => {
            if (res.status) {
                setList(res.result.list)
                setCount(res.result.count)
                setTodayCount(res.result.todayCount)
            }
        })
    }, [currentPage, searchQuery, refresh])



    return (
        <React.Fragment>

            <SearchCandidate
                setSearchQuery={setSearchQuery}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                list={list}
                count={count}
                todayCount={todayCount}
                setRefresh={setRefresh}
                refresh={refresh}
            />
        </React.Fragment>
    )
}

export default List